import { render, staticRenderFns } from "./GameSummaryRound.vue?vue&type=template&id=eb90e430&scoped=true"
import script from "./GameSummaryRound.vue?vue&type=script&lang=js"
export * from "./GameSummaryRound.vue?vue&type=script&lang=js"
import style0 from "./GameSummaryRound.vue?vue&type=style&index=0&id=eb90e430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb90e430",
  null
  
)

export default component.exports